import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthShell from "@/platform/components/AuthShell";
import { Button } from "@/platform/components/primitives";
import OtpInput from "@/platform/components/OtpInput";
import { api } from "@/platform/api";

export default function Verify() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [devCode, setDevCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [resendMsg, setResendMsg] = useState("");

  useEffect(() => {
    const e = sessionStorage.getItem("pinlayr.signup.email");
    if (!e) {
      navigate("/signup", { replace: true });
      return;
    }
    setEmail(e);
    setDevCode(sessionStorage.getItem("pinlayr.signup.devcode") || "");
  }, [navigate]);

  const verify = async (value) => {
    const c = (value || code).trim();
    if (c.length !== 6 || loading) return;
    setLoading(true);
    setError("");
    try {
      const res = await api.post("/api/auth/verify-otp", { email, code: c });
      sessionStorage.setItem("pinlayr.signup.vtoken", res.verification_token);
      navigate("/account");
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const resend = async () => {
    setError("");
    setResendMsg("");
    try {
      const res = await api.post("/api/auth/resend-otp", { email });
      if (res.dev_code) {
        setDevCode(res.dev_code);
        sessionStorage.setItem("pinlayr.signup.devcode", res.dev_code);
      }
      setResendMsg("A new code is on its way.");
    } catch (err) {
      setError(err.message);
    }
  };

  const useAnother = () => {
    sessionStorage.removeItem("pinlayr.signup.email");
    sessionStorage.removeItem("pinlayr.signup.devcode");
    sessionStorage.removeItem("pinlayr.signup.vtoken");
    navigate("/signup");
  };

  return (
    <AuthShell footer={<span>Wrong address? <button onClick={useAnother} className="font-semibold text-[#F4F5F8] hover:underline">Use another email</button></span>}>
      <div className="animate-in fade-in duration-500">
        <h1 className="text-[26px] font-semibold tracking-tight text-[#F4F5F8]">Check your email</h1>
        <p className="mt-2 text-[15px] text-[#98A0B0]">
          Enter the 6-digit code we sent to<br />
          <span className="font-semibold text-[#F4F5F8]">{email}</span>
        </p>

        {devCode && (
          <div className="mt-5 rounded-lg border border-amber-400/30 bg-amber-400/10 px-3.5 py-2.5 text-[12.5px] text-amber-200" data-testid="dev-code-hint">
            <span className="font-semibold">Dev mode:</span> your code is <span className="font-mono font-bold tracking-widest">{devCode}</span>
          </div>
        )}

        <div className="mt-6">
          <OtpInput value={code} onChange={setCode} onComplete={verify} disabled={loading} error={!!error} />
          {error && <p className="mt-3 text-[12.5px] text-red-500" data-testid="otp-error">{error}</p>}
          {resendMsg && !error && <p className="mt-3 text-[12.5px] text-[#16A34A]">{resendMsg}</p>}
        </div>

        <div className="mt-6">
          <Button onClick={() => verify()} loading={loading} disabled={code.length !== 6} data-testid="verify-submit">Verify</Button>
        </div>

        <p className="mt-6 text-center text-[13px] text-[#98A0B0]">
          Didn’t get it? <button onClick={resend} className="font-semibold text-[#F4F5F8] hover:underline">Resend code</button>
        </p>
      </div>
    </AuthShell>
  );
}
